// Generated by `pnpm gen:svg` from src/assets/svg — do not edit.
import type { SVGProps } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  ref?: Ref<SVGSVGElement>;
}
const SvgDuck = ({
  title,
  titleId,
  ref,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    id="Vrstva_1"
    data-name="Vrstva 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="306 170 220 220"
    width="1em"
    height="1em"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <defs>
      <style>{`
.dk-1 {
  fill: #ffa600;
}

.dk-1,
.dk-2,
.dk-3,
.dk-4,
.dk-5,
.dk-6,
.dk-7 {
  stroke-miterlimit: 10;
}

.dk-1,
.dk-2,
.dk-3,
.dk-6,
.dk-7 {
  stroke-width: 0.25px;
}

.dk-1,
.dk-3,
.dk-6,
.dk-7 {
  stroke: #1d1d1b;
}

.dk-2 {
  stroke: #fff;
}

.dk-3,
.dk-8,
.dk-5 {
  fill: #fff;
}

.dk-9 {
  fill: #484747;
}

.dk-10 {
  fill: #f39ee5;
}

.dk-4,
.dk-5 {
  stroke: #000;
  stroke-width: 0.5px;
}

.dk-11 {
  fill: var(--mascot-accent, #ff49a4);
  opacity: 0.4;
}

.dk-6 {
  fill: #ffd300;
}
`}</style>
    </defs>
    <path
      className="dk-8"
      d="M521.47,284.79c0,35.48-17.52,66.86-44.39,85.97-.73.52-1.48,1.04-2.23,1.54-.05.03-.09.06-.14.09-.09.06-.18.12-.27.18-.89.6-1.79,1.19-2.71,1.75-13.76,8.58-29.64,14.08-46.68,15.51-2.97.26-5.97.39-9.01.39-1.48,0-2.96-.03-4.43-.1-19.6-.8-37.81-6.96-53.22-17.06-.04-.02-.09-.05-.13-.08,0,0,0-.01-.02-.01-.23-.17-.49-.31-.72-.49-.01,0-.01-.01-.02-.01-28.26-18.9-46.88-51.12-46.88-87.68,0-58.22,47.2-105.43,105.42-105.43s105.43,47.21,105.43,105.43Z"
    />
    <path
      className="dk-11"
      d="M521.47,284.79c0,35.48-17.52,66.86-44.39,85.97-.73.52-1.48,1.04-2.23,1.54-.05.03-.09.06-.14.09-.09.06-.18.12-.27.18-.89.6-1.79,1.19-2.71,1.75-13.76,8.58-29.64,14.08-46.68,15.51-2.97.26-5.97.39-9.01.39-1.48,0-2.96-.03-4.43-.1-19.6-.8-37.81-6.96-53.22-17.06-.04-.02-.09-.05-.13-.08,0,0,0-.01-.02-.01-.23-.17-.49-.31-.72-.49-.01,0-.01-.01-.02-.01-28.26-18.9-46.88-51.12-46.88-87.68,0-58.22,47.2-105.43,105.42-105.43s105.43,47.21,105.43,105.43Z"
    />
    <path d="M493.25,335.54c.59-1.9-6.85-11.21-12-17.52-5.16-6.28-10.69-13.2-16.27-18.6-2.29-2.22-5.62-5.25-8.73-8.03-.68-.64-1.35-1.24-2-1.82-2.16-1.91-4.04-3.57-5.21-4.6-.78-.69-1.23-1.09-1.23-1.09,0,0-1.42,12.52-.72,18.08.02.17.04.32.08.49.77,5.52,2.98,12.9,7.16,17.92.73.86,1.46,1.65,2.24,2.4.46.43.94.88,1.43,1.29.45.4.98.8,1.53,1.22.71.57,1.43,1.09,2.17,1.63.11.06.22.15.33.24.29.21.56.41.86.62,1.62,1.13,3.26,2.3,4.92,3.63.24.18.48.37.71.57.28.24.54.46.79.68,5.35,4.64,12.88,11.93,14.83,11.24,1.96-.7,8.55-6.45,9.13-8.37Z" />
    <path d="M338.85,335.54c-.59-1.9,6.85-11.21,12-17.52,5.16-6.28,10.69-13.2,16.27-18.6,2.29-2.22,5.62-5.25,8.73-8.03.68-.64,1.35-1.24,2-1.82,2.16-1.91,4.04-3.57,5.21-4.6.78-.69,1.23-1.09,1.23-1.09,0,0,1.42,12.52.72,18.08-.02.17-.04.32-.08.49-.77,5.52-2.98,12.9-7.16,17.92-.73.86-1.46,1.65-2.24,2.4-.46.43-.94.88-1.43,1.29-.45.4-.98.8-1.53,1.22-.71.57-1.43,1.09-2.17,1.63-.11.06-.22.15-.33.24-.29.21-.56.41-.86.62-1.62,1.13-3.26,2.3-4.92,3.63-.24.18-.48.37-.71.57-.28.24-.54.46-.79.68-5.35,4.64-12.88,11.93-14.83,11.24-1.96-.7-8.55-6.45-9.13-8.37Z" />
    <path
      className="dk-8"
      d="M474.44,372.57c-.89.6-1.79,1.19-2.71,1.75-13.76,8.58-29.64,14.08-46.68,15.51-2.97.26-5.97.39-9.01.39-1.48,0-2.96-.03-4.43-.1-19.6-.8-37.81-6.96-53.22-17.06-.04-.02-.09-.05-.13-.08,0,0,0-.01-.02-.01-.23-.17-.49-.31-.72-.49-.72-6.75-.49-13.81.9-21.04,1.23-6.38,2.65-12.64,4.3-18.7.82-3.05,1.71-6.03,2.65-8.95t0-.01c.03-.12.07-.24.11-.36,4.75-14.75,10.93-27.76,18.85-37.28.06-.07.12-.14.17-.21,8.2-9.77,18.22-15.82,30.38-16.24.34-.02.68-.02,1.02-.02h.31c.67,0,1.33.02,1.98.06,11.61.55,21.43,6.1,29.51,15.15.33.37.66.75,1,1.14,7.81,9.19,13.97,21.72,18.54,36.18,1.17,3.7,2.24,7.53,3.19,11.46,1.41,5.73,2.6,11.68,3.57,17.78,1.16,7.28,1.25,14.37.44,21.13Z"
    />
    <path
      className="dk-4"
      d="M466.93,322.2c-9.07,18.54-28.59,31.37-51.19,31.37s-41.26-12.27-50.57-30.15c9.85-30.63,25.96-53.76,50.74-53.76s41.36,21.96,51.02,52.53Z"
    />
    <path
      className="dk-2"
      d="M452,277.66s.07-.01.07-.01c-4.88,15.37-15.36,25.4-18.67,36.42-4.42,14.68-5.76,29.78-7.01,31.14-2.52,2.7-17.58,2.7-20.92,0-1.68-1.37-1.17-15.69-6.17-28.73-5.69-14.78-6.5-16.98-13.81-28.31.01-.03.03-.07.07-.1-4.42-6.74-10.64-19.26-10.64-30.65,0-25.47,18.19-46.12,40.6-46.12s40.6,20.65,40.6,46.12c0,7.27-1.48,14.14-4.12,20.24Z"
    />
    <g>
      <path
        className="dk-10"
        d="M384.8,272.31c1.31-.54,2.19-1.08,2.72-2.38.53-1.3.27-2.3-.3-3.59-.57-1.29-1.97-2.49-3.17-3.01-1.2-.52-2.03-.7-3.32-.46-1.29.23-3.29,1.5-3.78,2.82-.48,1.32-.27,2.3.3,3.59.57,1.29,1.58,2.37,3.17,3,1.59.64,3.07.56,4.38.02Z"
      />
      <path
        className="dk-10"
        d="M445.97,272.26c-1.32-.51-2.21-1.03-2.76-2.33-.55-1.29-.31-2.29.23-3.59.54-1.3,1.92-2.53,3.11-3.07,1.19-.54,2.02-.74,3.31-.53,1.29.21,3.32,1.44,3.83,2.75.51,1.31.31,2.29-.23,3.6-.54,1.3-1.53,2.4-3.11,3.07-1.57.67-3.06.62-4.38.11Z"
      />
    </g>
    <path
      className="dk-9"
      d="M392.63,220.31c-4.07,3.34-7.89,7.45-10.62,12.25-3.56-1.71-7.23-4.05-7.75-6.53-.97-4.57,1.01-9.33,3.9-11.28,2.89-1.95,5.46-2.03,8.85-1.17,1.65.41,3.84,3.6,5.63,6.73Z"
    />
    <path
      className="dk-9"
      d="M457.11,226.03c-.53,2.47-4.7,4.82-8.26,6.53-2.73-4.79-5.89-8.03-9.95-11.38,1.79-3.13,3.82-7.18,5.47-7.6,3.38-.87,5.96-.78,8.85,1.17,2.89,1.95,4.86,6.71,3.9,11.28Z"
    />
    <path
      className="dk-5"
      d="M390.53,251.11c.09-5.45-4.28-9.94-9.75-10.03-5.47-.09-9.98,4.27-10.06,9.72-.09,5.45,4.28,9.94,9.75,10.03,5.47.09,9.98-4.27,10.06-9.72Z"
    />
    <path d="M381.57,259.24c4.47.69,8.27-3.09,7.59-7.54-.43-2.77-2.7-5.03-5.47-5.46-4.47-.69-8.27,3.09-7.59,7.54.43,2.77,2.7,5.03,5.47,5.46Z" />
    <path
      className="dk-5"
      d="M459.9,251.11c.09-5.45-4.28-9.94-9.75-10.03-5.47-.09-9.98,4.27-10.06,9.72-.09,5.45,4.28,9.94,9.75,10.03,5.47.09,9.98-4.27,10.06-9.72Z"
    />
    <path d="M446.91,258.88c4.47.69,8.27-3.09,7.58-7.54-.43-2.77-2.7-5.03-5.47-5.46-4.47-.69-8.27,3.09-7.58,7.54.43,2.77,2.7,5.03,5.47,5.46Z" />
    <path
      className="dk-6"
      d="M418.35,209.9s-.01-.01-.01-.02M426.4,199.79c-.23,0-.45.02-.67.06-.7.01-1.49.12-2.35.33-1.47.36-3.13,1.02-4.79,1.95-1.79.99-3.32,2.15-4.43,3.3-.85-.43-1.77-.72-2.75-.87-.42-.06-.86-.09-1.3-.09-1.79,0-3.45.52-4.84,1.41-.26.16-.51.34-.75.54-2.02,1.6-3.31,4.05-3.31,6.79,0,.35.02.69.07,1.02.17,1.51.73,2.89,1.59,4.06.61.83,1.36,1.56,2.23,2.14.77.47,1.69.89,2.73,1.23,2.47.82,5.61,1.25,9.01,1.13,3.71-.14,7.08-.92,9.56-2.08,2.5-1.33,4.48-2.93,5.54-5.48.58-1.35.89-2.98.89-4.98,0-5.78-2.88-10.46-6.43-10.46Z"
    />
    <path
      className="dk-6"
      d="M423.4,199.45c0,5.32-2.52,9.15-10.06,9.15s-10.06-3.83-10.06-9.15,4.5-9.63,10.06-9.63,10.06,4.31,10.06,9.63Z"
    />
    <path
      className="dk-1"
      d="M412.59,205.74c-.09.91-2.67,1.38-5.75,1.07-3.08-.31-5.51-1.3-5.42-2.21.03-.27.28-.51.71-.69.89-.39,1.7-.95,2.3-1.71.43-.54,1.06-.89,1.76-.89.74,0,1.39.38,1.82.98.67.93,1.63,1.61,2.71,1.99,1.19.43,1.92.96,1.87,1.46Z"
    />
    <circle className="dk-7" cx={413.15} cy={200.06} r={1.85} />
    <ellipse
      className="dk-7"
      cx={403.91}
      cy={198.02}
      rx={1.85}
      ry={0.4}
      transform="translate(146.63 567.02) rotate(-81.23)"
    />
    <circle className="dk-3" cx={412.05} cy={199.36} r={0.32} />
    <ellipse
      className="dk-3"
      cx={404.18}
      cy={197.45}
      rx={0.32}
      ry={0.07}
      transform="translate(147.43 566.81) rotate(-81.23)"
    />
    <path
      className="dk-6"
      d="M431.96,211.33c-.03.08-.14.35-.28.67-.5,1.2-.61,1.44-.7,1.61,0,0-.26.5-.59,1-.44.65-2.5,3.08-4.82,2.41-1.73-.51-3.08-2.54-2.63-4.48.24-1.03.88-2.21,4.6-3.06,1.83-1.42,2.45-3.26,3.82-2.31,1.08.75.97,3.22.59,4.17Z"
    />
  </svg>
);
export { SvgDuck };
